import i18n from "~/i18n/i18n";

export type JobStep = "Final" | "Start" | `Step${number}`;

export interface JobStepPosition {
	parentProductionJobId?: null | string;
	stepCount?: null | number;
	stepNumber?: null | number;
}

// wsapi's Step column values: Final (no parent job), Start (every non-final job, the legacy saved value), Step<n>.
const STEP_VALUE_PATTERN = /^Step(\d+)$/;

export const JOB_STEP_FILTER_VALUES: JobStep[] = ["Step1", "Step2", "Step3", "Step4", "Step5", "Step6", "Final"];

export const JOB_STEP_ACCEPTED_VALUES: JobStep[] = ["Start", ...JOB_STEP_FILTER_VALUES];

export const isStepNFilterValue = (value: string | null | undefined): boolean =>
	value != null && STEP_VALUE_PATTERN.test(value);

const stepNumberOfValue = (value: string): number | null => {
	const match = STEP_VALUE_PATTERN.exec(value);
	return match ? Number(match[1]) : null;
};

const labelFor = (stepNumber: number, isFinal: boolean): string => {
	if (isFinal) return i18n.t("schedule.jobStep.final", { ns: "produce" });
	if (stepNumber <= 1) return i18n.t("schedule.jobStep.start", { ns: "produce" });
	return i18n.t("schedule.jobStep.step", { ns: "produce", step: stepNumber });
};

export const formatJobStepCell = ({ parentProductionJobId, stepCount, stepNumber }: JobStepPosition): string => {
	if (stepNumber == null || stepNumber < 1) return labelFor(1, !parentProductionJobId);
	if (stepCount == null) return labelFor(stepNumber, !parentProductionJobId);
	return labelFor(stepNumber, stepNumber >= stepCount);
};

const formatJobStepLabel = (value: string | null | undefined): string => {
	if (!value) return "";
	if (value === "Final") return i18n.t("schedule.jobStep.final", { ns: "produce" });
	if (value === "Start") return i18n.t("schedule.jobStep.start", { ns: "produce" });
	const stepNumber = stepNumberOfValue(value);
	if (stepNumber == null) return "";
	return stepNumber === 1
		? i18n.t("schedule.jobStep.startStep1", { ns: "produce" })
		: i18n.t("schedule.jobStep.step", { ns: "produce", step: stepNumber });
};

export default formatJobStepLabel;
